// src/pages/GalleriesPhotos/RemovePhotoFromAlbumModal.jsx
import React, { useState, useEffect } from "react";
import { FaTrash, FaTimes } from "react-icons/fa";
import Button from "./../../components/Button/Button";
import {
  getPhotosByGalleryId,
  deletePhoto,
} from "./../../services/photoServices";
import { toast } from "react-toastify";

const RemovePhotoFromAlbumModal = ({ isOpen, onClose, galleryId }) => {
  const [photos, setPhotos] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState("");

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const data = await getPhotosByGalleryId(galleryId);
        setPhotos(data || []);
        if (data && data.length > 0) {
          setSelectedPhoto(data[0].id);
        }
      } catch (error) {
        console.error("Failed to fetch photos:", error);
      }
    };

    if (galleryId && isOpen) {
      fetchPhotos();
    }
  }, [galleryId, isOpen]);

  if (!isOpen) return null;

  const currentPhoto = photos.find((p) => p.id === Number(selectedPhoto));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await deletePhoto(selectedPhoto);
      onClose();
      toast.success("Photo supprimée avec succès.");
    } catch (error) {
      console.error("Erreur lors de la suppression de la photo:", error);
      toast.error("Erreur lors de la suppression de la photo.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="modal-box bg-white dark:bg-slate-900 dark:text-white p-5 rounded-2xl shadow-2xl max-w-lg w-full">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-bold uppercase tracking-[0.18em]">
            Supprimer une Photo
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-black/10 dark:bg-black/30 hover:bg-black/30 dark:hover:bg-black/60"
          >
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <select
            value={selectedPhoto}
            onChange={(e) => setSelectedPhoto(e.target.value)}
            className="select select-bordered w-full mb-4 dark:text-white dark:bg-slate-800 dark:border-slate-700 text-sm"
          >
            {photos.map((photo) => (
              <option key={photo.id} value={photo.id}>
                {photo.description || `Photo ${photo.id}`}
              </option>
            ))}
          </select>

          {currentPhoto && (
            <div className="mb-4 text-center">
              <p className="text-xs text-slate-500 dark:text-slate-300 mb-2">
                Aperçu de la photo sélectionnée :
              </p>
              <img
                src={currentPhoto.photo_url}
                alt="Aperçu"
                className="max-h-52 w-full object-contain rounded-lg border border-slate-200 dark:border-slate-700"
              />
            </div>
          )}

          <div className="flex flex-row justify-center gap-4">
            <Button
              text="Supprimer"
              icon={FaTrash}
              type="submit"
              className="gap-2 bg-rose-600 hover:bg-rose-700 text-white"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={onClose}
              className="gap-2 btn-ghost"
              type="button"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default RemovePhotoFromAlbumModal;
